<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { getAppConfig } from '../../../common/config/app-config';
  import { isMobileWidth } from '../../../common/util';
  import HorizontalDivider from '../../common/components/HorizontalDivider.svelte';
  import Icon from '../../common/components/Icon.svelte';
  import Tag from '../../common/components/tag/Tag.svelte';
  import Text from '../../common/components/Text.svelte';
  import { getBlogDateFormat, getBlogImageAltTextFromUrl, truncateString } from '../services/blog-data-services';
  import { blogBaseUrl } from '../store/blog_store';

  export let featurePost;
  export let imageOrder: number = 0;
  const { encodedContextPath } = getAppConfig();
  const isResponsive = isMobileWidth();
  const tagBackgroundColorCode: string = '#FFECA1';
  const tagTextColorCode: string = '$neutral-dark-01';
  $: imgUrl = isResponsive ? featurePost?.blogImage + '?fmt=auto&h=171' : featurePost?.blogImage + '?fmt=auto&h=507';
</script>

<a href={`${$blogBaseUrl}/${featurePost?.blogCategoryid}/${featurePost?.blogPostKey}`} class="blog-variant2-container">
  {#if isResponsive}
    <LayoutGrid>
      <Cell class="blog-text-container" spanDevices={{ phone: 4 }}>
        <div class="blog-text mobile">
          <div>
            {#if featurePost?.blogTitle}
              <div class="blog-title">
                <h2>{featurePost?.blogTitle}</h2>
              </div>
            {/if}
            {#if featurePost?.blogSubTitle}
              <div class="blog-sub-title">
                <h5>{featurePost?.blogSubTitle}</h5>
              </div>
            {/if}
          </div>
          {#if featurePost.blogCategoryname}
            <div class="blog-tag">
              <Tag
                label={featurePost?.blogCategoryname}
                backgroundColorCode={tagBackgroundColorCode}
                textColorCode={tagTextColorCode}
                fontSize={isResponsive ? 12 : 16}
              />
            </div>
          {/if}
        </div>
      </Cell>
      <Cell class="blog-image-container" spanDevices={{ phone: 4 }}>
        <div class="blog-image">
          <img src={imgUrl} alt={getBlogImageAltTextFromUrl(imgUrl)} />
        </div>
      </Cell>
      <Cell class="blog-text-container" spanDevices={{ phone: 4 }}>
        <div class="blog-text">
          {#if featurePost?.blogDescription}
            <div class="blog-description">
              <p>
                {truncateString(featurePost?.blogDescription, 220)}
                <a href={`${$blogBaseUrl}/${featurePost?.blogCategoryid}/${featurePost?.blogPostKey}`}>
                  <Text key="extra.ampliance.blog.read.more" />
                </a>
              </p>
            </div>
          {/if}
          {#if featurePost.tags && featurePost.tags.length}
            <div class="blog-tag-links">
              {#each featurePost.tags as link}
                - <a href="{encodedContextPath}{link.link}">{link.label}</a>
              {/each}
            </div>
          {/if}
          {#if featurePost?.readTime || featurePost?.date}
            <HorizontalDivider height="1" />
          {/if}
          <div class="blog-variant2-content">
            {#if featurePost?.date}
              <div class="blog-published-div">
                <Icon glyph="icon-published-new" type="primary" desktopSize={28} />
                <Text key="extra.ampliance.blog.publish.text" args={[getBlogDateFormat(featurePost.date)]} />
              </div>
            {/if}
            {#if featurePost?.readTime}
              <div class="blog-read-div">
                <Icon glyph="icon-watch-icon" type="primary" desktopSize={28} />
                <Text key="extra.ampliance.blog.readtime.text" args={[featurePost?.readTime]} />
              </div>
            {/if}
          </div>
        </div>
      </Cell>
    </LayoutGrid>
  {:else}
    <LayoutGrid>
      <Cell
        class="blog-image-container"
        style={`order: ${imageOrder}`}
        spanDevices={{ desktop: 6, tablet: 4, phone: 2 }}
      >
        <div class="blog-image">
          <img
            class={imageOrder === 0 ? 'left-image' : 'right-image'}
            src={imgUrl}
            alt={getBlogImageAltTextFromUrl(imgUrl)}
          />
        </div>
      </Cell>
      <Cell
        class="{imageOrder === 0 ? 'right-text' : 'left-text'} blog-text-container"
        spanDevices={{ desktop: 6, tablet: 4, phone: 2 }}
      >
        <div class="blog-text">
          {#if featurePost.blogCategoryname}
            <div class="blog-tag">
              <Tag
                label={featurePost?.blogCategoryname}
                backgroundColorCode={tagBackgroundColorCode}
                textColorCode={tagTextColorCode}
                fontSize={isResponsive ? 12 : 16}
              />
            </div>
          {/if}
          {#if featurePost?.blogTitle}
            <div class="blog-title">
              <h2>{featurePost?.blogTitle}</h2>
            </div>
          {/if}
          {#if featurePost?.blogSubTitle}
            <div class="blog-sub-title">
              <h5>{featurePost?.blogSubTitle}</h5>
            </div>
          {/if}
          {#if featurePost?.blogDescription}
            <div class="blog-description">
              <p>
                {truncateString(featurePost?.blogDescription, 220)}
                <a href={`${$blogBaseUrl}/${featurePost?.blogCategoryid}/${featurePost?.blogPostKey}`}>
                  <Text key="extra.ampliance.blog.read.more" />
                </a>
              </p>
            </div>
          {/if}
          {#if featurePost.tags && featurePost.tags.length}
            <div class="blog-tag-links">
              {#each featurePost.tags as link}
                - <a href="{encodedContextPath}{link.link}">{link.label}</a>
              {/each}
            </div>
          {/if}
          {#if featurePost?.readTime || featurePost?.date}
            <HorizontalDivider height="2" />
          {/if}
          <div class="blog-variant2-content">
            {#if featurePost?.date}
              <div class="blog-published-div">
                <Icon glyph="icon-published-new" type="primary" desktopSize={28} />
                <Text key="extra.ampliance.blog.publish.text" args={[getBlogDateFormat(featurePost.date)]} />
              </div>
            {/if}
            {#if featurePost?.readTime}
              <div class="blog-read-div">
                <Icon glyph="icon-watch-icon" type="primary" desktopSize={28} />
                <Text key="extra.ampliance.blog.readtime.text" args={[featurePost?.readTime]} />
              </div>
            {/if}
          </div>
        </div>
      </Cell>
    </LayoutGrid>
  {/if}
  </a>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .blog-variant2-container {
    .blog-image-container {
      .right-image {
        border-radius: 0px 20px 20px 0px;
      }
      .left-image {
        border-radius: 20px 0px 0px 20px;
      }
      .blog-image,
      img {
        height: 100%;
        object-fit: cover;
        border-radius: 0 20px 20px 0;
        width: 100%;
      }
      img {
        height: 507px;
        @include desktop-max-width {
          border-radius: 12px;
          height: 171px;
        }
      }
    }
    .blog-text {
      display: flex;
      flex-flow: column;
      gap: 20px;
      @include desktop-max-width {
        gap: 18px;
      }

      &.mobile {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .blog-title {
        h2 {
          font-size: 36px;
          line-height: 40px;
          color: $neutral-dark-01;
          font-weight: 700;
          margin: 0;
          @include desktop-max-width {
            font-size: 20px;
            line-height: 22px;
          }
        }
      }
      .blog-sub-title {
        h5 {
          margin: 0;
          font-size: 24px;
          line-height: 28px;
          color: $neutral-dark-01;
          font-weight: 500;
          @include desktop-max-width {
            font-size: 14px;
            line-height: 22px;
            font-weight: 400;
          }
        }
      }
      .blog-description {
        p {
          font-size: 20px;
          line-height: 24px;
          color: $neutral-dark-01;
          font-weight: 400;
          margin: 0;
          @include desktop-max-width {
            font-size: 14px;
            line-height: 16px;
          }
        }
        a {
          cursor: pointer;
          text-decoration: underline;
          font-weight: 400;
        }
      }
      .blog-tag-links {
        display: flex;
        gap: 4px;
        font-size: 20px;
        font-weight: 400;
        line-height: 26px;
        text-align: flex-start;
        a {
          color: $neutral-dark-01;
          text-decoration: underline;
          font-weight: 400;
        }
        @include desktop-max-width {
          font-size: 14px;
          line-height: 18px;
        }
      }
      .blog-variant2-content {
        display: flex;
        flex-direction: row;
        gap: 26px;
        .blog-published-div,
        .blog-read-div {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 18px;
          font-weight: 400;
          line-height: 20px;
          @include desktop-max-width {
            font-size: 13px;
            line-height: 15px;
          }
        }
      }
    }
    :global {
      .left-text {
        border-radius: 20px 0px 0px 20px !important;
      }
      .right-text {
        border-radius: 0px 20px 20px 0px;
      }
      .blog-text-container {
        padding: 52px 99px 50px 66px;
        background: $neutral-light-05;
        border-radius: 0 20px 20px 0;
        @include desktop-max-width {
          padding: 26px 20px 20px 20px;
          border-radius: 0;
        }
        .blog-tag {
          height: 100%;

          .tag {
            font-weight: 500;
            line-height: 14px;
            text-align: center;
            padding: 9px 8px;
            @include desktop-max-width {
              padding: 4px 12px;
            }
          }
        }
      }
    }
    :global(.blog-image-container) {
      @include desktop-max-width {
        padding: 20px;
      }
    }
    :global(.mdc-layout-grid) {
      padding: 0;
      border: 1px solid $secondary-gray-02;
      border-radius: 20px;
      @include desktop-max-width {
        border-radius: 0;
        background: rgba(251, 251, 252, 1);
      }
    }
    :global(.mdc-layout-grid__inner) {
      gap: 0;
      @include desktop-max-width {
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>
